import styled from "styled-components";

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 24px;
`;

export const CardTop = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const CardHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
    width: 100%;
    position: relative;
    & > .add-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    }
`;

export const CardHeaderTitle = styled.div`
    display: flex;
    flex: 1;
`;

export const CardMeta = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
    width: 100%;
`;

export const CardMetaItem = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
`;

export const MenuIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    cursor: pointer;
   
`;
